import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { ICatalog, IDesign, IPackage, IProduct, IFont, IArtist, IProductCategory, IDesignCategory } from '@/utils/types'
import * as CatalogService from '@/api/catalogService'

@Module({ dynamic: true, store, name: 'catalog' })
class Catalog extends VuexModule implements ICatalog {
    public busy = false
    public products: IProduct[] = []
    public packages: IPackage[] = []
    public designs: IDesign[] = []
    public productCategories: IProductCategory[] = []
    public designCategories: IDesignCategory[] = []
    public fonts: IFont[] = []
    public colors: string[] = []
    public styles: string[] = []
    public subjects: string[] = []
    public artists: IArtist[] = []

    @Mutation
    private SET_COLORS(colors: string[]) {
        this.colors = colors
    }

    @Mutation
    private SET_STYLES(styles: string[]) {
        this.styles = styles
    }

    @Mutation
    private SET_SUBJECTS(subjects: string[]) {
        this.subjects = subjects
    }

    @Mutation
    private SET_ARTISTS(artists: IArtist[]) {
        this.artists = artists
    }

    @Action
    public async getTags() {
        const response = await CatalogService.getTags()
        this.SET_COLORS(response.data.colors)
        this.SET_STYLES(response.data.styles)
        this.SET_SUBJECTS(response.data.subjects)
    }

    @Action
    public async getArtists() {
        const response = await CatalogService.getArtists()
        this.SET_ARTISTS(response.data)
    }

    @Mutation
    private SET_LOADING(busy: boolean) {
        this.busy = busy
    }

    @Mutation
    private SET_CATALOG(catalog: ICatalog) {
        this.products = catalog.products.filter(item => item.id != -1)
        this.packages = catalog.packages.filter(item => item.id != -1)
        this.designs = catalog.designs.filter(item => item.id != -1)
        this.productCategories = catalog.productCategories.filter(item => item.id != -1)
        this.designCategories = catalog.designCategories.filter(item => item.id != -1)
        this.fonts = catalog.fonts
    }

    @Action
    public async getCatalog() {
        this.SET_LOADING(true)
        try {
            const response = await CatalogService.getCatalog()
            this.SET_CATALOG(response.data)
        } catch (err) {
            console.error("Failed to get catalog data", err)
        } finally {
            this.SET_LOADING(false)
        }
    }

    @Action
    public async refreshCatalog() {
        try {
            await CatalogService.refreshcatalog()
            this.getCatalog()
        } catch (err) {
            console.error("Failed to refresh catalog data", err)
        }
    }
}

export const CatalogModule = getModule(Catalog)
